import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-logout-01-Bulk',
  standalone: true,
  templateUrl: '../../assets/logout-01/Bulk.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamLogout01BulkIcon {}
